import React from "react";
import { Truck, Package, Clock, Shield } from "lucide-react";
import hundaiLogo from "../Assets/hundaiLogo.png";
import tataicon from "../Assets/tataicon.png";
import jswLogo from "../Assets/jswLogo.png";
import boingLogo from "../Assets/boingLogo.png";
import eicherLogo from "../Assets/eicherLogo.png";

const Services = () => {
  const services = [
    {
      icon: <Truck className="h-8 w-8 text-[#F80D01]" />,
      title: "Full Load Transport",
      description:
        "Dedicated vehicles for your bulk cargo needs with nationwide coverage and real-time tracking.",
    },
    {
      icon: <Package className="h-8 w-8 text-[#F80D01]" />,
      title: "Part Load Services",
      description:
        "Cost-effective solutions for smaller shipments with optimized routes and quick delivery.",
    },
    {
      icon: <Clock className="h-8 w-8 text-[#F80D01]" />,
      title: "Express Delivery",
      description:
        "Time-critical shipments handled with priority for urgent transportation needs.",
    },
    {
      icon: <Shield className="h-8 w-8 text-[#F80D01]" />,
      title: "Secure Transport",
      description:
        "Enhanced security measures for valuable and sensitive cargo transportation.",
    },
  ];

  const logos = [hundaiLogo, tataicon, jswLogo, boingLogo, eicherLogo];

  return (
    <section id="services" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16 animate-slide-in">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Our Services
          </h2>
          <p className="text-xl text-gray-600">
            Comprehensive transportation solutions tailored to your needs
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {services.map((service, index) => (
            <div
              key={index}
              className="bg-white p-6 rounded-lg shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-2 group"
              style={{ animationDelay: `${index * 150}ms` }}
            >
              <div className="mb-4 transform group-hover:scale-110 transition-transform duration-300">
                {service.icon}
              </div>
              <h3 className="text-xl font-semibold mb-2 group-hover:text-[#F80D01] transition-colors">
                {service.title}
              </h3>
              <p className="text-gray-600">{service.description}</p>
            </div>
          ))}
        </div>

        <div className="bg-gray-200 py-8 mt-12">
          <marquee scrollamount="5">
            <div className="flex space-x-8 items-center">
              {logos.map((logo, index) => (
                <img
                  key={index}
                  src={logo}
                  alt={`Company logo ${index + 1}`}
                  className="h-12 w-auto object-contain"
                />
              ))}
            </div>
          </marquee>
        </div>
      </div>
    </section>
  );
};

export default Services;
